/**
 * API Configuration
 * Centralized API URL configuration for the application
 */

// Get API URL using environment variables with fallback
export const API_URL = window.ENV?.API_URL || process.env.REACT_APP_DEV_API_URL || 'http://localhost:5001';

// Export other API-related constants if needed
export const API_ENDPOINTS = {
  PROFILE: '/api/profile',
  CAPTCHA: '/api/captcha',
  CONTACT: '/api/contact',
} as const;
